import { HLabel, HLabelMap } from '@/common/hlabel';
import * as React from 'react';
import type { JSX } from 'react';

const HLabelContent = ({ hlabelPath, hlabel }: { hlabelPath?: string; hlabel?: HLabel }) => {
  // 递归渲染标签函数
  const renderLabels = (label: HLabel, level = 1) => {
    if (!label) return null;

    const HeadingTag = `h${Math.min(level, 6)}` as keyof JSX.IntrinsicElements;

    return (
      <>
        <HeadingTag>{label.text}</HeadingTag>
        {label.children?.map((child, index) => <div key={index}>{renderLabels(child, level + 1)}</div>)}
      </>
    );
  };
  return <div style={{ display: 'none' }}>{renderLabels(hlabel ?? HLabelMap.get(hlabelPath))}</div>;
};

export default HLabelContent;
